exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-partner .logo{background:linear-gradient(114.27deg,#7e43aa 5.39%,#421f5b 98.22%)!important;border-radius:10px}.captcha-config{margin-top:20px;width:100%;display:block}.captcha-config div{display:block;margin:0 0 0 auto}.signinv2{background-image:none}.signinv2 .content-info{background:#339;background:linear-gradient(180deg,#339 40%,#1f1f77 70%);width:67%;height:100%}.signinv2 .content-info .img1 img{margin:-40px auto -10px!important}.signinv2 .text-info1{padding:0 17%!important}.signinv2 .text-info1 strong{color:#fff!important}.signinv2 .text-info2{margin-left:5%;font-size:1.5rem!important;font-weight:400!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17f3caf6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/views/public/login/LoginPartner.vue
// module id = 813
// module chunks = 0